const CIVIL_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;
export const SUPPLIER_BUSINESS_TIME_ZONE = 'America/Sao_Paulo';

function civilDateParts(value: string): { year: number; month: number; day: number } | null {
  const match = CIVIL_DATE_PATTERN.exec(value);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year
    || date.getUTCMonth() !== month - 1
    || date.getUTCDate() !== day
  ) {
    return null;
  }
  return { year, month, day };
}

export function civilDateISO(date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: SUPPLIER_BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const value = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${value.year}-${value.month}-${value.day}`;
}

export function nextCivilDateISO(date = new Date()): string {
  const current = civilDateParts(civilDateISO(date));
  if (!current) return '';
  return new Date(Date.UTC(current.year, current.month - 1, current.day + 1))
    .toISOString()
    .slice(0, 10);
}

export function isFutureCivilDate(value: string, now = new Date()): boolean {
  const parts = civilDateParts(value);
  if (!parts || value.length !== 10) return false;
  return value > civilDateISO(now);
}

export function formatCivilDate(value?: string | null, fallback = '-'): string {
  if (!value) return fallback;
  const parts = civilDateParts(value);
  if (!parts) return fallback;

  const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(date);
}

export function formatLocalDate(value?: string | null, fallback = '-'): string {
  if (!value) return fallback;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return fallback;
  return new Intl.DateTimeFormat('pt-BR').format(date);
}

export function formatLocalDateTime(value?: string | null, fallback = 'Não informado'): string {
  if (!value) return fallback;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return fallback;
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
}
